import { createI18n, I18nOptions } from 'vue-i18n'
import { getTranslations } from './es/index'

const messages = {
  es: getTranslations(),
} as I18nOptions['messages']

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'es',
  fallbackLocale: 'es',
  messages,
})

// Función independiente de vue-i18n.
// Se usa para archivos de TS donde no llega la super función '$t'.
export const _i18n = (path: string, named?: Record<string, unknown>) =>
  i18n.global.t(path, named ?? {})

export default i18n
